import { vendorSchema } from '@server/presentation'
import { z } from 'zod'

export const registerCardReqSchema = z.object({
  cardNumber: z.string(),
  cardExp: z.string(),
  cardPassword: z.string(),
  cardBirthDate: z.string(),
  vendor: vendorSchema,
})

export const rawRegisterCardReqSchema = z.object({
  cardNum: z.string(),
  cardExp: z.string(),
  cardPw: z.string(),
  cardBirth: z.string(),
  vendor: vendorSchema,
})

export type RegisterCardReq = z.infer<typeof registerCardReqSchema>
export type RawRegisterCardReq = z.infer<typeof rawRegisterCardReqSchema>

export const registerCardReqAdapter = (req: RegisterCardReq): RawRegisterCardReq => {
  return {
    cardNum: req.cardNumber,
    cardExp: req.cardExp,
    cardPw: req.cardPassword,
    cardBirth: req.cardBirthDate,
    vendor: req.vendor,
  } satisfies RawRegisterCardReq
}
